import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'hub-breadcrumb',
    templateUrl: './hub-breadcrumb.component.html',
})

export class HubBreadcrumbComponent implements OnInit {

    public breadcrumbs: object[];

    public title: any;

    public breadLabelCount: number = 0;

    public lastBreadLink: string;

    @Input() public showTitle: boolean = false;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
    ) { }

    public ngOnInit() {
        this.subscribeBreadcrumb();
    }

    public subscribeBreadcrumb() {

        // Route change subscribe
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                this.setBreadcrumb();
            });
    }

    public ngAfterContentInit() {
        // Called after ngOnInit when the component's or directive's content has been initialized.
        // Add 'implements AfterContentInit' to the class.
        this.setBreadcrumb();
    }

    public setBreadcrumb() {

        let currentRoute = this.route.root;
        let url = '';

        this.breadcrumbs = [{
            label: 'Home',
            url: '/',
        }];

        do {

            const childrenRoutes = currentRoute.children;
            currentRoute = null;

            childrenRoutes.forEach((route) => {

                if (route.outlet === 'primary' && route.component !== undefined) {

                    // get Bread label and url
                    const path = route.snapshot.url
                        .map((segment) => segment.path)
                        .join('/');

                    url += (path) ? '/' + path : '/' + route.parent.snapshot.url
                        .map((segment) => segment.path)
                        .join('/');

                    if (route.snapshot.data.breadcrumb) {
                        this.breadcrumbs.push({
                            label: route.snapshot.data.breadcrumb,
                            url,
                        });
                    }

                    // get page title
                    const title = route.snapshot.data.title;
                    this.title = (title) ? title : (route.parent.snapshot.data.title) ? route.parent.snapshot.data.title : '';
                }
                currentRoute = route;
            });
        } while (currentRoute);

        this.responsive();
    }

    public responsive() {

        this.breadLabelCount = this.breadcrumbs.length;
        if (this.breadcrumbs[this.breadLabelCount - 2]) {
            this.lastBreadLink = (this.breadcrumbs[this.breadLabelCount - 2] as any).url;
        }
    }
}
